"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FieldRenderer = _interopRequireDefault(require("../FieldRenderer"));
var _constants = require("../constants");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldGroup = _interopRequireDefault(require("../FieldGroup"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var isFieldGroup = field => field.type === _constants.FIELD_TYPES.FIELD_GROUP_FIELD;
var StepTrackerSteps = props => {
  var _steps$currentStep;
  var {
    steps = [],
    fieldValues = {},
    preFillValues = {},
    language = _constants.CONTENTFUL_LOCALE.en,
    clickedSubmit = false,
    fieldReferences = {},
    fieldData = {},
    isProduction = false,
    environment = 'sandbox'
  } = props;
  var {
    currentStep
  } = (0, _useStepTrackerContext.default)();
  var fields = ((_steps$currentStep = steps[currentStep]) === null || _steps$currentStep === void 0 ? void 0 : _steps$currentStep.fields) || [];
  var renderField = field => {
    if (isFieldGroup(field)) {
      return /*#__PURE__*/_react.default.createElement(_FieldGroup.default, {
        key: "field-group-".concat(field.id),
        heading: field.heading,
        subheading: field.subheading,
        fields: field.fields,
        fieldValues: fieldValues,
        preFillValues: preFillValues,
        language: language,
        mobileWidth: field.mobileWidth,
        tabletWidth: field.tabletWidth,
        desktopWidth: field.desktopWidth,
        clickedSubmit: clickedSubmit,
        fieldReferences: fieldReferences,
        fieldData: fieldData,
        removeSpacing: field.removeSpacing,
        isProduction: isProduction,
        environment: environment
      });
    } else {
      return _FieldRenderer.default.renderField(field, fieldValues, preFillValues, language, clickedSubmit, fieldReferences[field.id], fieldData, fieldReferences, isProduction, environment);
    }
  };
  var renderedFields = fields.map(renderField).filter(field => field !== undefined);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderedFields);
};
StepTrackerSteps.propTypes = {
  steps: _propTypes.default.array,
  fieldValues: _propTypes.default.object,
  preFillValues: _propTypes.default.object,
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  fieldReferences: _propTypes.default.object,
  fieldData: _propTypes.default.object,
  isProduction: _propTypes.default.bool,
  environment: _propTypes.default.string
};
var _default = exports.default = StepTrackerSteps;